import React from 'react'
import Hero from '../component/room/Hero'
import RoomsSection from './../component/room/RoomsSection';


const Room = () => {
  return (
      <div>
      {/* <Hero /> */}
      <RoomsSection />
    </div>
  )
}

export default Room

